var m = require('mithril');
var prop = require('mithril/stream');
var dragscroll = require('../libs/dragscroll');
var loaders = require('../layout/components/loaders');
var heading = require('../components/heading');
var paginationWithSearch = require('../data/components/paginationWithSearch');
var mapUtils = require('../maps/mapUtils');
var moment = require('moment');

var component = {};
var NETWORK_PATH_MODE = 'network';
var LOCATION_EQUIPMENT_PATH_MODE = 'locationEquipment';

function getPathDisplayOptions(vnode) {
  var options = (vnode.attrs && vnode.attrs.pathDisplayOptions) || {};
  var pathMode = options.pathMode || options.mode || NETWORK_PATH_MODE;
  return {
    pathMode: pathMode === LOCATION_EQUIPMENT_PATH_MODE ? LOCATION_EQUIPMENT_PATH_MODE : NETWORK_PATH_MODE,
    fallbackToNetworkPath: options.fallbackToNetworkPath !== false,
    omitMissingPath: options.omitMissingPath === true,
    showNodeClass: options.showNodeClass !== false
  };
}

function normalizeRidForRoute(record) {
  var rid = record && record['@rid'];
  if (!rid) return '';
  return rid.toString().replace(/^#/, '');
}

function pointDetailHref(pointRecord) {
  return '/point/' + normalizeRidForRoute(pointRecord);
}

function formatLocationLabel(path) {
  if (!path) return '';
  if (path.name === 'root') return 'Home';
  var pathClass = path['@class'] || '';
  var pathName = path.name || pathClass || 'Record';
  if (mapUtils.isRoomClass(pathClass) && path.roomNumber) {
    return (pathName + ' ' + path.roomNumber).trim();
  }
  return pathName;
}

function pathNodeLabel(path, pointRecord, pathDisplayOptions) {
  var pathClass = path && path['@class'] ? path['@class'] : '';
  var pathName = mapUtils.isLocationClass(pathClass) ? formatLocationLabel(path) : (path && path.name ? path.name : 'Record');

  if (pathClass == pointRecord['@class'] || !pathDisplayOptions.showNodeClass) {
    return pathName;
  }

  return pathClass ? pathClass + ': ' + pathName : pathName;
}

function getPointPath(pointRecord, pathDisplayOptions) {
  pointRecord = pointRecord || {};
  var locationEquipmentPaths = Array.isArray(pointRecord.locationEquipmentPaths) ? pointRecord.locationEquipmentPaths : [];
  var locationEquipmentPath = Array.isArray(pointRecord.locationEquipmentPath) ? pointRecord.locationEquipmentPath : locationEquipmentPaths[0];

  if (pathDisplayOptions.pathMode === LOCATION_EQUIPMENT_PATH_MODE && Array.isArray(locationEquipmentPath) && locationEquipmentPath.length) {
    return locationEquipmentPath;
  }

  if (pathDisplayOptions.pathMode === LOCATION_EQUIPMENT_PATH_MODE && !pathDisplayOptions.fallbackToNetworkPath) {
    return [];
  }

  return Array.isArray(pointRecord.path) ? pointRecord.path : [];
}

function pointRecordHasSelectedPath(pointRecord, pathDisplayOptions) {
  return !pathDisplayOptions.omitMissingPath || getPointPath(pointRecord, pathDisplayOptions).length > 0;
}

function buildPathSearchLabel(pointRecord, pathDisplayOptions) {
  return getPointPath(pointRecord, pathDisplayOptions).map(function (path) {
    return pathNodeLabel(path, pointRecord, {
      pathMode: pathDisplayOptions.pathMode,
      showNodeClass: false
    });
  }).join(' ');
}

function pathNodeHref(path, pointRecord, pathDisplayOptions) {
  var pathClass = path && path['@class'] ? path['@class'] : '';
  var pathRid = normalizeRidForRoute(path);

  if (pathClass == pointRecord['@class']) {
    return '/#/point/' + normalizeRidForRoute(pointRecord);
  }

  if (pathDisplayOptions.pathMode === LOCATION_EQUIPMENT_PATH_MODE) {
    if (pathClass === 'Dashboard') {
      return '/#/dashboard/' + pathRid;
    }
    if (mapUtils.isLocationClass(pathClass)) {
      return '/#/location/' + pathRid;
    }
    return '/#/equipment/' + pathClass.toLowerCase() + '/' + pathRid;
  }

  if(pathClass.slice(0, 4) == 'Rest' || pathClass.slice(0, 6) == 'Bacnet' || pathClass == 'FunctionBlock' || pathClass == 'LontalkCnip'){
    return '/#/' + pathClass.toLowerCase() + '/' + pathRid;
  }

  var link = pathClass ? pathClass.charAt(0).toLowerCase() + pathClass.slice(1) : 'point';
  return '/#/' + link + '/' + pathRid;
}

function renderPathNode(path, pointRecord, pathDisplayOptions, fullPath, idx, pathRecords) {
  var isLast = idx === pathRecords.length - 1;
  return [
    m('a', {
      class: isLast ? 'pl1' : 'mh1',
      title: fullPath,
      href: pathNodeHref(path, pointRecord, pathDisplayOptions)
    }, pathNodeLabel(path, pointRecord, pathDisplayOptions)),
    isLast ? null : '>'
  ];
}

component.oninit = function (vnode) {
  var ctrl = this;
  ctrl.alarmRecordsToShow = [];
  ctrl.newNode = prop(false);

  ctrl.prepareAlarmRecord = function (record) {
    if (!record) return record;
    record.pathSearchLabel = buildPathSearchLabel(record, ctrl.pathDisplayOptions);
    return record;
  };

  ctrl.loadAlarms = function (vnode) {
    ctrl.rid = (vnode.attrs && vnode.attrs.rid) || m.route.param('rid');
    ctrl.embedded = vnode.attrs && vnode.attrs.embedded;
    ctrl.headingLabel = (vnode.attrs && vnode.attrs.headingLabel) || 'Alarms';
    ctrl.pathDisplayOptions = getPathDisplayOptions(vnode);

    if (!ctrl.embedded) {
      document.title = 'nimrod | Alarms';
    }

    ctrl.pointsWithEnabledAlarm = null;
    return loaders.requestWithLoader({
      url: "/api/v1/user/" + ctrl.rid + "/alarms",
      method: "GET",
    })
    .then(function(data){
      ctrl.pointsWithEnabledAlarm = Array.isArray(data) ? data : [];
      ctrl.pointsWithEnabledAlarm.forEach(function (p) {
        if (Array.isArray(p.path)) {
          p.path = p.path.slice().reverse();
        } else {
          p.path = [];
        }
        p.locationEquipmentPaths = Array.isArray(p.locationEquipmentPaths) ? p.locationEquipmentPaths : [];
        p.locationEquipmentPath = Array.isArray(p.locationEquipmentPath)
          ? p.locationEquipmentPath
          : (p.locationEquipmentPaths[0] || []);
        ctrl.prepareAlarmRecord(p);
      });
      ctrl.newNode(true);
    })
  };

  ctrl.loadAlarms(vnode);
}

component.onupdate = function (vnode) {
  var ctrl = this;
  var nextRid = (vnode.attrs && vnode.attrs.rid) || m.route.param('rid');
  ctrl.pathDisplayOptions = getPathDisplayOptions(vnode);
  if (Array.isArray(ctrl.pointsWithEnabledAlarm)) {
    ctrl.pointsWithEnabledAlarm.forEach(ctrl.prepareAlarmRecord);
  }

  if (nextRid && nextRid !== ctrl.rid) {
    ctrl.loadAlarms(vnode);
  }
}

component.view = function () {
  var ctrl = this

  if(!ctrl.pointsWithEnabledAlarm){
    return m('div')
  }
  var alarmRecords = ctrl.pointsWithEnabledAlarm.filter(function (pointRecord) {
    return pointRecordHasSelectedPath(pointRecord, ctrl.pathDisplayOptions);
  });

  return m('div', { class: ctrl.embedded ? '' : 'mh3' }, [
    m(heading,{label: ctrl.headingLabel, class: ctrl.embedded ? 'f1 mb3 pb1 display' : 'f-subheadline mb3 pb1 display'}),
    m(paginationWithSearch, {
      data: alarmRecords,
      newNode: ctrl.newNode,
      dataToShow: ctrl.alarmRecordsToShow,
      placeHolder: 'Search alarms',
      itemsPerPage: 30,
      fieldsToSearch: ['alarmName', 'pathSearchLabel'],
      hideSearch: alarmRecords.length <= 10
    }, [
      m('div.dragscroll-container', { style: { width: '100%', maxWidth: '100%' } }, [
        m('div.dragscroll.mega-menu-dragscroll.pr2', {
          oncreate: dragscroll,
          onupdate: dragscroll,
          style: { width: '100%', maxWidth: '100%', overflowX: 'auto', overflowY: 'hidden' }
        }, [
          m('table.f4.mb3', { style: { minWidth: '100%', tableLayout: 'auto' } }, [
            m('thead', [
              m('tr', [
                m('th.ph0.pv1.tl.nowrap', 'Alarm Name'),
                m('th.ph0.pv1.tl.nowrap', 'Last Trip Timestamp'),
                m('th.ph0.pv1.tl.nowrap', 'Path'),
              ])
            ]),
            m('tbody', [
            ctrl.alarmRecordsToShow.map( pointRecord => {
                if (!pointRecord || !pointRecord['@rid']) {
                  return m('tr', [
                    m('td.tl.pv1.nowrap', [
                      m('label', { style: { visibility: 'hidden' } }, 'No Data')
                    ]),
                    m('td.tl.pv1.nowrap'),
                    m('td.tl.pv1.nowrap')
                  ]);
                }

                var pointPath = getPointPath(pointRecord, ctrl.pathDisplayOptions);
                let fullPath = pointPath.map(path => {
                  return pathNodeLabel(path, pointRecord, {
                    pathMode: ctrl.pathDisplayOptions.pathMode,
                    showNodeClass: false
                  });
                }).join(' > ');
                return m('tr', [
                  m('td.tl.pv1.nowrap', { title: pointRecord.alarmName || '' }, [
                    m(m.route.Link, {
                      href: pointDetailHref(pointRecord),
                      class: 'blue link'
                    }, pointRecord.alarmName || '')
                  ]),
                  m('td.tl.pv1.nowrap', pointRecord.lastTripTimestamp ? moment(new Date(pointRecord.lastTripTimestamp)).format('MM/DD/YYYY h:mm:ss a') : ''),
                  m('td.tl.pv1.nowrap', [
                    pointPath.length
                      ? pointPath.map(function (path, idx) {
                        return renderPathNode(path, pointRecord, ctrl.pathDisplayOptions, fullPath, idx, pointPath);
                      })
                      : m('a', { class: 'pl1', href: '/#/point/' + normalizeRidForRoute(pointRecord) }, pointRecord.name || pointRecord['@rid'])
                  ])
                ])
              })
            ]),
          ])
        ])
      ])
    ])
  ])
 }

module.exports = component;
